type CategoryName = 'Analytics' | 'Functional';

export async function getConsentCategoryState(categoryName: CategoryName) : Promise<boolean> {
  try {
    const details = await window.__ucCmp.getConsentDetails();

    for (const category of Object.values(details.categories)) {
      if (category.name === categoryName) {
        return category.state === 'ALL_ACCEPTED';
      }
    }

    return false;
  } catch {
    return false;
  }
}
